import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../../controls/conversions';
import { formatToFractional } from '../../../controls/conversions';

const WindowWidthTotal = ({ value, onChange, id = 'WindowWidthTotal', label = 'Window Width Total', minW = 20, maxW = 500,
                       doorSizeValue = null, doorHeightValue = null, passSelectedDoor,
                       disabled = false
 }) => {
    const [selectedWindowWidthTotal, setSelectedWindowWidthTotal] = useState(value || "40\"");
     const [WindowWidthTotalError, setWindowWidthTotalError] = useState("");

    useEffect(() => {
    validateWindowWidthTotal(selectedWindowWidthTotal, minW, maxW);
    }, [minW, maxW]);
       
     useEffect(() => {
        setSelectedWindowWidthTotal(value || "40\"");
    }, [value]);

     const calcWidth = (doorType, doorSize) => {
        if (doorType === 1) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 1).toString() + ' 1/2"';
        }
        if ([2, 3].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 17).toString() + '"';
        }
        if (doorType === 4) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 32).toString() + ' 1/2"';
        }
        if (doorType === 5) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2).toString() + '"';
        }
        if ([6, 7].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 17).toString() + ' 1/2"';
        }
        if (doorType === 8) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2*17 - 1).toString() + '"';
        }
        return 0;
     }
    useEffect(() => {
        if (passSelectedDoor) {
            if (passSelectedDoor.id > 4) {
                validateWindowWidthTotal(selectedWindowWidthTotal,minW, maxW);

            }
            else {

                validateWindowWidthTotal(selectedWindowWidthTotal, minW, maxW);

            }
            //alert(selectedWindowWidthTotal);
            //validateWindowWidthTotal(selectedWindowWidthTotal);
        }
        if (!doorSizeValue) {
            const element = document.getElementById("DoorSize");
            if (element) { 
                doorSizeValue = element.value;
            }
        }
        if (doorHeightValue) {}
        if (passSelectedDoor && doorSizeValue) {
            //alert(JSON.stringify(passSelectedDoor, null, 2));
            const w = calcWidth(passSelectedDoor.id, doorSizeValue);
            setSelectedWindowWidthTotal(w);
            validateWindowWidthTotal(w);
            onChange(w);
        }
      }, [doorSizeValue, doorHeightValue, passSelectedDoor, value]); // Trigger effect whenever doorSizeValue changes

    const handleWindowWidthTotalChange = (e) => {
        //setSelectedWindowWidthTotal(e.target.value);
        validateWindowWidthTotal(e.target.value);
        // Don't call onChange here - only update on blur to avoid intermediate render issues
    };

    const validateWindowWidthTotal = (value, mmin = null, mmax = null) => {
        
        if (mmin === null) mmin = minW;
        if (mmax === null) mmax = maxW;
        const numericValue = formatToDecimal(value);
        setSelectedWindowWidthTotal(value);
        if (numericValue && (numericValue < mmin || numericValue > mmax)) {
            setWindowWidthTotalError(`must be between ${mmin} and ${mmax}`);
        } else {
            setWindowWidthTotalError("");
        }
    };


        
    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === 0) decimalValue = "";
      setSelectedWindowWidthTotal(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedWindowWidthTotal(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="WindowWidthTotal">{label}</label>
            <input
                disabled={disabled}
                id={id}
                value={selectedWindowWidthTotal}
                onChange={handleWindowWidthTotalChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {WindowWidthTotalError && <p className="error">{WindowWidthTotalError}</p>}
        </div>
    );
};

export default WindowWidthTotal;